"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voice-chat.error.noModelOrAvatar': 'Wybierz model lub awatar, aby rozpocząć rozmowę głosową.',
};
